import React from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import {
  Checkbox,
  Typography,
  MenuItem,
  Button,
  MenuList,
  ClickAwayListener,
  Grow,
  Paper,
  Popper,
  Tooltip
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles(theme => ({
  button: {
    margin: '0px 8px',
    fontWeight: 'normal',
    color: 'rgba(0,0,0,.55) !important',
    opacity: '1 !important'
  },
  selected: {
    color: theme.palette.primary.main,
    margin: '0px 8px'
  },
  list: {
    overflow: 'auto',
    maxHeight: '31vh'
  },
  checkbox: {
    paddingLeft: '0px'
  }
}));

export default function Filters(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { filter, action } = props;
  const { options, onChange, title } = filter;
  const [isSelected, setIsSelected] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  /* eslint-disable react-hooks/exhaustive-deps */
  React.useEffect(() => {
    setIsSelected(options.filter(i => i.checked).length > 0);
  }, [options]);

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };

  const handleClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleChange = event => {
    let newOptions = options.map(option => {
      if (option.value === event.value) {
        option.checked = !option.checked;
      }
      return option;
    });
    onChange(
      newOptions.filter(option => option.checked).map(option => option.value)
    );
    dispatch(action);
  };

  return (
    <>
      <Tooltip title={options.length === 0 ? `Not applicable` : ``}>
        <div>
          <Button
            aria-label={`Filter ${title}`}
            ref={anchorRef}
            className={isSelected ? classes.selected : classes.button}
            onClick={handleToggle}
            disabled={options.length === 0}
            endIcon={<ExpandMoreIcon />}>
            {title}
          </Button>
        </div>
      </Tooltip>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom'
            }}>
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList className={classes.list} id="split-button-menu">
                  {options.map((option, index) => (
                    <MenuItem key={index} onClick={() => handleChange(option)}>
                      <Checkbox
                        checked={option.checked}
                        color="primary"
                        className={classes.checkbox}
                        value="true"
                      />
                      <Typography variant="inherit">
                        {option.value.toUpperCase()}
                      </Typography>
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
}
